import GuestHubGuestListGuestEmail from "./GuestHubGuestListGuestEmail";

export default GuestHubGuestListGuestEmail;
